export default __webpack_public_path__ + "static/media/y_wdt_c_1.286cb25c.mp3";